import UIComponent from '../../common/UIComponent';
import { clearAllNode } from '../../common/Utils';
import log from 'loglevel';
import './index.css';

export default class DefinitionBtn extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.Lang = interfaces.language;
    this.definitionMap = new Map();
    this.init();

    this.interfaces.on(VhallPlayer.DEFINITION_CHANGE, res => {
      let def;
      switch (res.newValue.def) {
        case 'a':
          def = this.Lang.definition.audio;
          break;
        case 'same':
          def = this.Lang.definition.same;
          break;
        default:
          def = res.newValue.def;
          break;
      }

      this.definitionBtn.innerText = def;

      for (let i = 0; i < document.querySelectorAll('.definition-list-box li').length; i++) {
        const value = document.querySelectorAll('.definition-list-box li')[i];
        value.removeAttribute('class');
        if (value.innerText === def) {
          value.classList.add('active');
        }
      }
    });

    this.interfaces.on(VhallPlayer.CHANGE_SCHEDULER_DATA, res => {
      this.initDefinitionListBox();
    });

    //
    this.interfaces.on(VhallPlayer.LIVESUBTITLE_OPENED, res => {
      this.initDefinitionListBox()
    });

    this.interfaces.on(VhallPlayer.LIVESUBTITLE_CLOSED, res => {
      this.initDefinitionListBox()
    });

    this.interfaces.on(VhallPlayer.REFRESH_DISPATCH_COMPLETED, res => {
      this.initDefinitionListBox()
    })
  }

  init() {
    // 清晰度组件容器
    this.definitionComponent = document.createElement('div');
    this.definitionComponent.setAttribute('class', 'vhallPlayer-definition-component');
    this.definitionComponent.onmouseleave = this.handleComponentMouseLeave.bind(this);

    // 清晰度按钮
    this.definitionBtn = document.createElement('span');
    this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn');
    this.definitionBtn.onclick = this.handleBtnClick.bind(this);
    switch (this.interfaces.getCurrentQuality().def) {
      case 'a':
        this.definitionBtn.innerText = this.Lang.definition.audio;
        break;
      case 'same':
        this.definitionBtn.innerText = this.Lang.definition.same;
        break;
      default:
        this.definitionBtn.innerText = this.interfaces.getCurrentQuality().def || '';
        break;
    }

    // 清晰度弹窗容器
    this.definitionListPopup = document.createElement('div');
    this.definitionListPopup.setAttribute('class', 'definition-popup');

    // 清晰度列表
    this.definitionListBox = document.createElement('ul');
    this.definitionListBox.setAttribute('class', 'definition-list-box');
    this.initDefinitionListBox()

    // 弹窗追加列表
    this.definitionListPopup.appendChild(this.definitionListBox);

    // 组件容器追加按钮
    this.definitionBtn.innerText && this.definitionComponent.appendChild(this.definitionBtn);

    // 组件容器追加弹窗
    this.definitionComponent.appendChild(this.definitionListPopup);

    this.insertElement(this.elementId, this.definitionComponent);
  }

  initDefinitionListBox() {
    // this.definitionListBox.innerHTML = "";
    clearAllNode(this.definitionListBox);
    let currentDefList = this.interfaces.getQualitys();
    for (let i = 0; i < currentDefList.length; i++) {
      const value = currentDefList[i];
      this.definitionItem = document.createElement('li');

      value.def === this.interfaces.getCurrentQuality().def ? this.definitionItem.classList.add('active') : undefined;

      switch (value.def) {
        case 'a':
          this.definitionItem.innerText = this.Lang.definition.audio;
          this.definitionMap.set(this.Lang.definition.audio, value);
          break;
        case 'same':
          this.definitionItem.innerText = this.Lang.definition.same;
          this.definitionMap.set(this.Lang.definition.same, value);
          break;
        default:
          this.definitionItem.innerText = value.def;
          this.definitionMap.set(value.def, value);
          break;
      }
      this.definitionItem.onclick = this.handleItemClick.bind(this);

      // 清晰度列表追加
      this.definitionListBox.appendChild(this.definitionItem);
    }

    let def;
    switch (this.interfaces.getCurrentQuality().def) {
      case 'a':
        def = this.Lang.definition.audio;
        break;
      case 'same':
        def = this.Lang.definition.same;
        break;
      default:
        def = this.interfaces.getCurrentQuality().def;
        break;
    }
    this.definitionBtn.innerText = def;
  }

  handleComponentMouseLeave() {
    this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn');
    this.definitionListPopup.style.display = 'none';
    // this.definitionListPopup.style.opacity = "0";
  }

  handleBtnClick() {
    this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn active');
    this.definitionListPopup.style.display = 'block';
    // this.definitionListPopup.style.opacity = "1";
  }

  handleItemClick(event) {
    for (let i = 0; i < document.querySelectorAll('.definition-list-box li').length; i++) {
      const value = document.querySelectorAll('.definition-list-box li')[i];
      value.removeAttribute('class');
    }
    event.target.classList.add('active');
    const value = event.target.innerText;
    this.definitionBtn.innerText = value;
    this.definitionBtn.setAttribute('class', 'vhallPlayer-definitionBtn');
    this.definitionListPopup.style.display = 'none';
    // this.definitionListPopup.style.opacity = "0";
    this.interfaces
      .setQuality(this.definitionMap.get(value))
      .then(() => {
        log.info('切换清晰度成功');
      })
      .catch(e => {
        log.warn('切换清晰度出现异常：', e);
      });
  }
}
